import classNames from 'classnames'
import { EnergyType } from 'types/producer'
import EnergyTypeIcon from '../energy-type-icon/EnergyTypeIcon'
import styles from './NewProducerMarker.module.scss'
import { NewProducerMapMarkerProps } from './types'
import ProducerMapCard from 'components/producers/producer-map-card/ProducerMapCard'
import { getProducerLocation } from 'utils/producers'
import { useRouter } from 'next/router'

const NewProducerMarker = ({ location, onMouseEnter, onMouseLeave, active, popup, onClick, index }: NewProducerMapMarkerProps) => {
  // Router
  const { locale } = useRouter()

  return (
    <>
      {popup ? (
        <div className={styles['producer-marker-card']}>
          <ProducerMapCard {...{ location }} />
        </div>
      ) : (
        <button
          className={classNames(styles['producer-marker'], { [styles['is-active']]: active })}
          onMouseEnter={() => onMouseEnter && onMouseEnter(location, index)}
          onMouseLeave={() => onMouseLeave && onMouseLeave()}
          onClick={(event) => {
            event.stopPropagation()
            if (onMouseLeave) onMouseLeave()
            if (onClick) onClick(location, index)
          }}
        >
          <EnergyTypeIcon energyType={location.energyType as EnergyType} className={styles.icon} />
          {active && <span className={styles.location}>{getProducerLocation(locale, location?.location)}</span>}
        </button>
      )}
    </>
  )
}

export default NewProducerMarker
